import React, { useState, useEffect, useCallback, useContext } from 'react'
import {
  Drawer,
  Steps,
  List,
  Avatar,
  Button,
  message,
  Card,
  Checkbox,
  Radio,
  Input,
  InputNumber,
  Tooltip,
  Space,
  Typography
} from 'antd'
import { Alert } from '@mercadoni/gungnir'
import { availability, createIssue, getItemByJob, getReasons } from '../../flag-management.services'
import NumberFormat from 'react-number-format'
import { useTranslation } from 'react-i18next'
import Icons from '@commonComponents/Icons'
import { Trash } from '@mercadoni/gungnir'
import Moment from 'react-moment'
import * as moment from 'moment'
import * as dayjs from 'dayjs'
import { standardDate } from '../../flag-management.tools'
import { formatMoney } from 'accounting-js'
import { REASON_PARAMS } from '../../../../utils/constants'
import { HistoricalContext } from '../../../../refactory/modules/jobs/infrastructure/job-detail/historical.context'
import { useAuth } from '../../../../auth/Auth.hook'
const { v4: uuidv4 } = require('uuid')

const { Step } = Steps
const { TextArea } = Input

const PricesTypes = {
  ORDER_VALUE: 'order_value',
  SHIPPING_FEE: 'shipping_fee',
  TAXES: 'taxes',
  DISCOUNTS: 'discounts',
  SUBTOTAL: 'subtotal'
}

const JobIssue = (props) => {
  const { t } = useTranslation()
  const [, updateState] = useState()
  const { userInfo } = useAuth()
  const [localItems, setLocalItems] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [slots, setSlots] = useState([])
  const [selectedSlot, setSelectedSlot] = useState()
  const [jobId, setJobId] = useState()
  const [current, setCurrent] = useState(0)
  const [comment, setComment] = useState('')
  const [textAreaLength, setTextAreaLength] = useState(0)
  const [showEditValues, setShowEditValues] = useState(false)
  const [invoiceUpdated, setInvoiceUpdated] = useState(false)
  const [isReasonOpen, setIsReasonOpen] = useState(false)
  const [replenishReasons, setReplenishReasons] = useState([])
  const [replenishReasonId, setReplenishReasonId] = useState(null)
  const { getJobHistorical } = useContext(HistoricalContext)
  const [newPrices, setNewPrices] = useState({
    subtotal: 0,
    taxes: 0,
    discounts: 0,
    shipping_fee: 0,
    order_value: 0,
    attributes: []
  })
  const { job, symbolValue, timeZone, checkoutInfo } = props
  const { Title } = Typography
  const forceRender = useCallback(() => updateState({}), [])
  const steps = [
    {
      description: t('jobs.job.info.items-view.issue-view.products'),
      content: 'products-content'
    },
    {
      description: t('jobs.job.info.items-view.issue-view.order-value'),
      content: 'invoice-content'
    },
    {
      description: t('jobs.job.info.items-view.issue-view.delivery-time'),
      content: 'delivery-content'
    },
    {
      description: t('jobs.job.info.items-view.issue-view.comment'),
      content: 'comment-content'
    }
  ]

  const next = () => {
    const start = dayjs().toISOString()
    const end = dayjs().add(7, 'day').toISOString()
    if (current === 0) {
      availability(jobId, start, end, selectedItems).then((result) => {
        if (result) {
          setSlots(result)
        }
      })
    }
    setCurrent(current + 1)
  }

  const prev = () => {
    setCurrent(current - 1)
  }

  const getReasonsList = async () => {
    const reasons = await getReasons(REASON_PARAMS.REPLENISH)
    if (reasons) {
      setReplenishReasons(reasons)
    }
  }
  useEffect(() => {
    if (props.visible) {
      getReasonsList()
    }
    cleanFields()
  }, [jobId, props.visible])

  const sendIssue = async () => {
    const id = uuidv4()
    await createIssue(jobId, selectedSlot, comment, REASON_PARAMS.REPLENISH, replenishReasonId, id, newPrices)
    props.handleJobIssue()
    getJobHistorical(props.jobId)
    cleanFields()
    message.success(t('jobs.job.info.items-view.issue-view.success'))
  }

  const cleanFields = () => {
    setCurrent(0)
    setSelectedItems([])
    setSelectedSlot(null)
    setComment('')
    setIsReasonOpen(false)
  }

  const onChangeItems = (selectedItems) => {
    setSelectedItems(selectedItems)
    setSelectedSlot(null)
  }

  const onSelectedSlot = (selectedSlot) => {
    setSelectedSlot(selectedSlot.target.value)
  }

  const onChangeComment = (comment) => {
    setComment(comment.target.value)
    setTextAreaLength(comment.target.length)
  }

  const getSumTotalValue = (prices) => {
    let total = 0
    Object.keys(prices).forEach((pricesKey) => {
      if (pricesKey !== 'attributes' && pricesKey !== 'order_value') {
        total += pricesKey === 'discounts' ? -1 * prices[pricesKey] : prices[pricesKey]
      }
    })
    return total
  }

  const handleChangePrices = (fieldName, value, _id) => {
    let _newPrices = newPrices
    if (!_id) {
      _newPrices = { ...newPrices, [fieldName]: value }
    } else {
      const attrIndex = newPrices?.attributes?.findIndex(({ id }) => id === _id)
      if (attrIndex >= 0) {
        _newPrices.attributes[attrIndex].value = value
      }
    }
    if (fieldName !== 'order_value') {
      _newPrices.order_value = getSumTotalValue(_newPrices)
    }
    setNewPrices(_newPrices)
    forceRender()
  }

  const handleChangeAttributeName = (_id, newName) => {
    const _newPrices = newPrices
    const attrIndex = newPrices?.attributes?.findIndex(({ id }) => id === _id)
    _newPrices.attributes[attrIndex].name = newName
    setNewPrices(_newPrices)
    forceRender()
  }

  const getAttributeValue = (attributes, _type, _id) => {
    const attribute = attributes?.find(({ id }) => id === _id)
    return attribute?.value || 0
  }

  const editFields = (name, invoiceValue, id = null) => {
    const negativeSign = name === 'discounts' && invoiceValue > 0 ? '- ' : ''
    const _value = id !== null ? getAttributeValue(newPrices?.attributes, name, id) : newPrices[name]
    const inputStyle = id === null && name !== 'order_value' ? { marginRight: '30px' } : {}
    return (
      <div>
        {showEditValues ? (
          <InputNumber
            onChange={(value) => handleChangePrices(name, value, id)}
            value={_value}
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={(value) => value.replace(/\\s?|(,*)/g, '')}
            className='edit-invoice-values'
            style={inputStyle}
            max={100000000000}
          />
        ) : (
          <span>
            {negativeSign}
            {formatMoney(invoiceValue, symbolValue)}
          </span>
        )}
      </div>
    )
  }

  const updatePaymentInfoPrices = () => {
    try {
      const _newPrices = JSON.parse(JSON.stringify(newPrices))
      _newPrices.attributes = _newPrices.attributes.map((a) => {
        delete a.id
        return a
      })

      setShowEditValues(false)
      setInvoiceUpdated(true)
    } catch (error) {
      setShowEditValues(false)
    }
  }
  const removeAttribute = (_id) => {
    const _newPrices = newPrices
    const attrIndex = newPrices?.attributes?.findIndex(({ id }) => id === _id)
    _newPrices.attributes?.splice(attrIndex, 1)
    setNewPrices(_newPrices)
    forceRender()
  }

  const getAttributesByType = (type = '', attributes = []) => {
    const mainClass = 'payment-summary-body-section-attributes'
    if (attributes.length === 0) {
      return null
    }
    const attributesByType = attributes.filter(({ type: _type }) => type === _type.toLowerCase())
    if (!attributesByType || attributesByType.length === 0) {
      return null
    }
    return (
      <div className={mainClass}>
        {attributesByType.map(({ id, name, value }, idx) => {
          return (
            <dl key={`pybs-${idx}`} className={`${mainClass}-item`} style={showEditValues ? { marginTop: '8px' } : {}}>
              <dt>
                {showEditValues ? (
                  <Input
                    value={name || ''}
                    onChange={({ target: { value: _value } }) => handleChangeAttributeName(id, _value)}
                  />
                ) : (
                  name
                )}
              </dt>
              <dd className={`${mainClass}-item-value`}>
                {editFields(type, value, id)}
                {showEditValues && <Trash onClick={() => removeAttribute(id)} />}
              </dd>
            </dl>
          )
        })}
      </div>
    )
  }

  const addNewAttribute = (type) => {
    const lastAttr = newPrices?.attributes?.length > 0 ? newPrices?.attributes?.[newPrices?.attributes?.length - 1] : {}
    const _newPrices = newPrices
    _newPrices?.attributes?.push({
      id: lastAttr?.id + 1 || 1,
      type: type.toUpperCase(),
      name: '',
      value: 0
    })
    setNewPrices(_newPrices)
    forceRender()
  }

  const getAddButton = (type) => {
    const mainClass = 'payment-summary'
    if (!showEditValues) return null
    return (
      <div className={`${mainClass}-body-add-button`}>
        <Button type='link' onClick={() => addNewAttribute(type)}>
          <u>{t(`addNew-${type}`)}</u>
          {' +'}
        </Button>
      </div>
    )
  }

  const showPaymentMethodTextAndIcon = (method) => {
    switch (method) {
      case 'CASH':
        return <Icons iconName='PaymentMethodCash' />
      case 'REPAID':
        return <Icons iconName='PaymentMethodCreditCard' />
      case 'PAYMENT_LINK':
        return <Icons iconName='PaymentMethodPaymentLink' />
      case 'PAYMENT_TERMINAL':
        return <Icons iconName='PaymentMethodPaymentTerminal' />
      case 'TRANSFER':
        return <Icons iconName='PaymentMethodTransfer' />
      case 'LOYALTY_CARD':
        return <Icons iconName='PaymentMethodLoyaltyCard' />
      default:
        break
    }
  }

  const showPaymentStatusTextAndIcon = (status) => {
    switch (status) {
      case 'succeeded':
        return <Icons iconName='PaymentStatusSuccess' />
      case 'failed':
        return <Icons iconName='PaymentStatusFailed' />
      case 'changed':
        return <Icons iconName='PaymentStatusChanged' />
      case 'reverted':
        return <Icons iconName='PaymentStatusReverted' />
      case 'in_progress':
        return <Icons iconName='PaymentStatusInProgress' />
      case 'pending':
        return <Icons iconName='PaymentStatusPending' />
      default:
        break
    }
  }

  const mapPricesToNewPrices = () => {
    const subtotal = 0
    const shipping_fee = job?.paymentInfo.prices.shippingFee
    const discounts = 0
    const taxes = 0
    const order_value = 0
    const totalOrder = 0

    const _newPrices = {
      subtotal: subtotal,
      shipping_fee: shipping_fee,
      discounts: discounts,
      taxes: taxes,
      order_value: order_value,
      totalOrder: totalOrder,
      attributes:
        newPrices?.attributes.map((a, idx) => {
          a.id = idx + 1
          return a
        }) || []
    }
    setNewPrices(_newPrices)
  }

  const getProductsByStatus = (products, _status) => {
    return products
      .filter(
        (product) =>
          product.rejected?.rejectedByDriver || product.rejected?.rejectedByUser || product.state.includes('REJECTED')
      )
      .map((product) => {
        return {
          ...product,
          foundQuantity: product.rejected
            ? product.rejected.rejectedByDriver + product.rejected.rejectedByUser
            : product.foundQuantity
        }
      })
  }
  const listInvoiceHeader = () => {
    const tooltipTextPaymentMethod = t(job.paymentInfo?.payment?.method)
    const textPaymentMethod = job.paymentInfo?.payment?.methodDetails
      ? job.paymentInfo?.payment?.methodDetails
      : tooltipTextPaymentMethod
    const paymentStatus = job.paymentInfo?.payment?.paymentStatus
      ? job.paymentInfo?.payment?.paymentStatus.toLowerCase()
      : 'pending'
    return (
      <React.Fragment>
        <Card className='invoice-header'>
          <dl className='invoice-header-fields'>
            <dt>{t('jobs.job.info.invoices.invoice')}</dt>
            <dd>{job.paymentInfo?.invoice?.reference || job.invoices?.billingNumber || ''}</dd>
          </dl>
          <dl className='invoice-header-fields'>
            <dt>{t('invoiced')}</dt>
            <dd>
              {checkoutInfo?.actualEnd ? (
                <Moment format='LL' tz={timeZone}>
                  {standardDate(checkoutInfo.actualEnd)}
                </Moment>
              ) : null}
            </dd>
          </dl>
          <dl className='invoice-header-fields'>
            <dt>{t('paymentMethod')}</dt>
            <dd>
              <label>
                {textPaymentMethod}{' '}
                <Tooltip placement='right' title={tooltipTextPaymentMethod}>
                  <span>{showPaymentMethodTextAndIcon(job.paymentInfo?.payment?.method)}</span>
                </Tooltip>
              </label>
            </dd>
          </dl>
          <dl className='invoice-header-fields'>
            <dt>{t('paymentStatus')}</dt>
            <dd>
              <label>
                {t(paymentStatus)} {showPaymentStatusTextAndIcon(paymentStatus)}
              </label>
            </dd>
          </dl>
          <dl className='invoice-header-fields'>
            <dt>{t('paymentStatusDetail')}</dt>
            <dd>
              <label>
                {job.paymentInfo?.payment.paymentStatusDetails
                  ? job.paymentInfo?.payment.paymentStatusDetails
                  : t('empty-text')}
              </label>
            </dd>
          </dl>
        </Card>
      </React.Fragment>
    )
  }

  const listInvoiceValues = () => {
    const subtotal = newPrices?.subtotal
    const shipping_fee = newPrices?.shipping_fee
    const taxes = newPrices?.taxes
    const discounts = newPrices?.discounts
    const totalOrder = 0
    const order_value = newPrices?.order_value
    const attributes = newPrices?.attributes || []
    const mainClass = 'payment-summary'
    const editLink = (
      <Button type='link' onClick={() => setShowEditValues(!showEditValues)} disabled={showEditValues}>
        <u>{t('editSummary')}</u>
      </Button>
    )

    return (
      <React.Fragment>
        {listInvoiceHeader()}
        <div className='div-alert-message-replenish'>
          <label>
            <Icons iconName='Warning' />
          </label>
          <p>{t('jobs.job.info.items-view.issue-view.warning-alert-replenish')}</p>
        </div>
        <Card className={mainClass} title={t('paymentSummary')} extra={editLink}>
          <div className={`${mainClass}-body`}>
            <div className={`${mainClass}-body-section`}>
              <dl>
                <dt className={`${mainClass}-body-section-title`}>{`${t('subtotal')}:`}</dt>
                <dd className={`${mainClass}-body-section-title`}>{editFields('subtotal', subtotal)}</dd>
              </dl>
              {getAttributesByType(PricesTypes.SUBTOTAL, attributes)}
            </div>
            {getAddButton(PricesTypes.SUBTOTAL)}
            <div className={`${mainClass}-body-section`}>
              <dl>
                <dt className={`${mainClass}-body-section-title`}>{`${t('shippingFee')}:`}</dt>
                <dd className={`${mainClass}-body-section-title`}>{editFields('shipping_fee', shipping_fee)}</dd>
              </dl>
              {getAttributesByType(PricesTypes.SHIPPING_FEE, attributes)}
            </div>
            <div className={`${mainClass}-body-section`}>
              <dl>
                <dt className={`${mainClass}-body-section-title`}>{`${t('totalOrder')}:`}</dt>
                <dd className={`${mainClass}-body-section-title`}>{formatMoney(totalOrder, symbolValue)}</dd>
              </dl>
              {getAttributesByType(PricesTypes.SHIPPING_FEE, attributes)}
            </div>
            {getAddButton(PricesTypes.SHIPPING_FEE)}
            <div className={`${mainClass}-body-section`}>
              <dl>
                <dt className={`${mainClass}-body-section-title`}>{`${t('taxes')}:`}</dt>
                <dd className={`${mainClass}-body-section-title`}>{editFields('taxes', taxes)}</dd>
              </dl>
              {getAttributesByType(PricesTypes.TAXES, attributes)}
            </div>

            {getAddButton(PricesTypes.TAXES)}

            <div className={`${mainClass}-body-section`}>
              <dl>
                <dt className={`${mainClass}-body-section-title`}>{`${t('discounts')}:`}</dt>
                <dd className='red-price'>{editFields('discounts', discounts)}</dd>
              </dl>
              {getAttributesByType(PricesTypes.DISCOUNTS, attributes)}
            </div>

            {getAddButton(PricesTypes.DISCOUNTS)}
          </div>
          <div className={`${mainClass}-total`}>
            <span>{t('totalToPay')}</span>
            <span>{editFields('order_value', order_value)}</span>
          </div>
          {showEditValues && (
            <div className={`${mainClass}-actions`}>
              <Button
                onClick={() => {
                  setShowEditValues(false)
                }}
              >
                {t('discard')}
              </Button>
              <Button type='primary' onClick={updatePaymentInfoPrices}>
                {t('saveChanges')}
              </Button>
            </div>
          )}
        </Card>
      </React.Fragment>
    )
  }

  const listRejectedProducts = (items) => {
    return (
      <React.Fragment>
        <p className='step-description'>{t('jobs.job.info.items-view.issue-view.list-items')}</p>
        <p className='description'>{t('jobs.job.info.items-view.issue-view.list-items-description')}</p>
        <List itemLayout='horizontal'>
          <Checkbox.Group className='checkbox-products' defaultValue={selectedItems} onChange={onChangeItems}>
            {getProductsByStatus(items).map((item) => {
              return (
                <List.Item key={item.itemId}>
                  <List.Item.Meta
                    avatar={<Avatar className='item-image' shape='square' size='large' src={item.photoUrl} />}
                    title={item.name}
                    description={
                      <div className='item-description-issue'>
                        <NumberFormat
                          value={item.presentation.price.amount}
                          displayType={'text'}
                          thousandSeparator
                          prefix={'$'}
                        />
                        <p className='replenish'>
                          {`${t('jobs.job.info.items-view.issue-view.replenish')} ${item.foundQuantity} ${t(
                            'jobs.job.info.items-view.issue-view.from'
                          )} ${item.quantity}`}
                        </p>
                      </div>
                    }
                  />
                  <Checkbox value={item.itemId} />
                </List.Item>
              )
            })}
          </Checkbox.Group>
        </List>
      </React.Fragment>
    )
  }

  const listDeliveryTime = () => {
    let currentDate = ''
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    const currentTimeZone = job.storeTimezone ? job.storeTimezone : userInfo.user.client.timeZone

    return (
      <React.Fragment>
        <p className='step-description'>{t('jobs.job.info.items-view.issue-view.list-delivery-time')}</p>
        <p className='description'>{t('jobs.job.info.items-view.issue-view.list-delivery-time-description')}</p>
        <p className='scheduled'>
          <Icons iconName='SlotCalendar' /> {t('jobs.job.info.items-view.issue-view.scheduled')}
        </p>
        <Radio.Group defaultValue={selectedSlot} onChange={onSelectedSlot}>
          {slots.map((slot) => {
            let dateCategory
            if (currentDate !== moment(slot.from).format('dddd D MMMM')) {
              dateCategory = (
                <React.Fragment>
                  <p className='secondary-text title-slot'>
                    <Moment format='dddd D MMMM' tz={currentTimeZone}>
                      {slot.to}
                    </Moment>
                  </p>
                </React.Fragment>
              )
              currentDate = moment(slot.from).format('dddd D MMMM')
            }
            return (
              <div key={slot.id}>
                {dateCategory}
                <Radio value={slot.id}>
                  <React.Fragment>
                    <span className='secondary-text'>
                      <Moment format='h:mm a' tz={currentTimeZone}>
                        {slot.from}
                      </Moment>{' '}
                      -
                      <Moment format='h:mm a' tz={currentTimeZone}>
                        {slot.to}
                      </Moment>
                    </span>
                  </React.Fragment>
                </Radio>
              </div>
            )
          })}
        </Radio.Group>
      </React.Fragment>
    )
  }
  const getReasonTitle = (id) => {
    let reason = replenishReasons.find((obj) => obj.id === id)
    return reason.title
  }
  const getReasonStatus = (id) => {
    let reason = replenishReasons.find((obj) => obj.id === id)
    return reason.metadata.openQuestion
  }

  const onChangeReason = (e) => {
    setComment(getReasonTitle(e.target.value))
    setIsReasonOpen(getReasonStatus(e.target.value))
    setReplenishReasonId(e.target.value)
    setTextAreaLength(0)
  }
  const replenishReasonsBanner = (
    <div className='replenish-reasons-banner'>
      <div className='replenish-reasons-icon-banner'>
        <Alert />
      </div>
      <span className='replenish-reasons-banner-text'>
        {t('jobs.job.info.items-view.issue-view.replenish-reasons-banner-text')}
      </span>
    </div>
  )
  const emptyReasonsMessage = (
    <div className='empty-reasons-message'>
      <img src='/error.png' alt='error' />
      <p className='empty-reasons-message-description'>
        {t('jobs.job.info.items-view.issue-view.replenish-reasons-empty')}
      </p>
    </div>
  )
  const addReason = () => {
    return (
      <div>
        <React.Fragment>
          <p className='step-description'>{t('jobs.job.info.items-view.issue-view.add-comment')}</p>
          <React.Fragment>
            {replenishReasonsBanner}
            <Title level={4} className='select-replenish-reason-title'>
              {t('jobs.job.info.items-view.issue-view.replenish-reasons-title')}
            </Title>
            {replenishReasons.length < 1 ? emptyReasonsMessage : null}
            <Radio.Group>
              <Space direction='vertical'>
                {replenishReasons.map((reason) => {
                  const isReasonEnabled = reason.metadata.enabled

                  if (isReasonEnabled) {
                    return (
                      <Radio value={reason.id} onChange={onChangeReason} className='cancellation-reasons-radio'>
                        {reason.title}
                      </Radio>
                    )
                  }
                  return null
                })}
              </Space>
            </Radio.Group>

            {isReasonOpen ? (
              <TextArea
                rows={4}
                placeholder={t('jobs.jobCancel.form.comment')}
                onChange={onChangeComment}
                maxLength={200}
                showCount
              />
            ) : null}
            {isReasonOpen && textAreaLength < 5 ? (
              <div className='reason-comment-minimum'>
                {t('jobs.job.info.items-view.issue-view.replenish-minimun-comment')}{' '}
              </div>
            ) : null}
            <div>
              <span>{t('jobs.jobCancel.form.responsible')}: </span>
              <b>
                {userInfo?.user.firstName} {userInfo?.user.lastName}
              </b>
            </div>
          </React.Fragment>
        </React.Fragment>
      </div>
    )
  }

  const isNextDisabled = (step) => {
    let disabled = true
    if (step === 'products-content') disabled = selectedItems.length === 0
    if (step === 'invoice-content') disabled = !invoiceUpdated
    if (step === 'delivery-content') disabled = !selectedSlot
    if (step === 'comment-content') disabled = (isReasonOpen && textAreaLength < 5) || replenishReasonId === null
    return disabled
  }

  const getItems = async () => {
    const { job } = props
    const items = await getItemByJob(job.id)

    cleanFields()
    setLocalItems(items)
    setJobId(props.job.id)
    setReplenishReasonId(null)
  }

  useEffect(() => {
    getItems()
  }, [props.job.id])
  useEffect(() => {
    mapPricesToNewPrices()
  }, [])

  return (
    <Drawer
      className='issue-drawer'
      title={t('jobs.job.info.items-view.issue-view.title')}
      width={600}
      placement='right'
      onClose={props.handleJobIssue}
      visible={props.visible}
    >
      <Steps progressDot current={current}>
        {steps.map((item) => (
          <Step key={item.description} description={item.description} />
        ))}
      </Steps>
      <div className='steps-content'>
        {steps[current].content === 'products-content' && listRejectedProducts(localItems)}
        {steps[current].content === 'invoice-content' && listInvoiceValues()}
        {steps[current].content === 'delivery-content' && listDeliveryTime()}
        {steps[current].content === 'comment-content' && addReason()}
      </div>
      <div className='steps-action'>
        {current > 0 && (
          <Button style={{ marginRight: 8 }} onClick={() => prev()}>
            {t('jobs.job.info.items-view.issue-view.btn-previous')}
          </Button>
        )}
        {current < steps.length - 1 && (
          <Button type='primary' onClick={() => next()} disabled={isNextDisabled(steps[current].content)}>
            {t('jobs.job.info.items-view.issue-view.btn-next')}
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button type='primary' onClick={() => sendIssue()} disabled={isNextDisabled(steps[current].content)}>
            {t('jobs.job.info.items-view.issue-view.btn-create')}
          </Button>
        )}
      </div>
    </Drawer>
  )
}

export default JobIssue
